import { createFileRoute } from "@tanstack/react-router";
import { PortfolioWorkspace } from "@/components/AdditionalWorkspaces";

export const Route = createFileRoute("/portfolio")({ component: PortfolioWorkspace });
